export const addUpdateTag = (target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor) => {
  const originalMethod = descriptor.value

  const handleFunction = fn => function (...args: any[]) {
    const res = fn.apply(target, args)
    target.needsUpdate = true
    return res
  }

  if (originalMethod)
    originalMethod.value = handleFunction(originalMethod)
  else
    descriptor.set = handleFunction(descriptor.set)
}